import {dashboardChartColors} from '../../../../../../../util/uiconstants';
import {labels as utilLabels} from '../../../../../../../util/utils';

import {config as barchartColumnConfig} from '../../../common/BarchartColumn';

export const prop = 'status';

export const config = (labels) =>
	barchartColumnConfig({
		id: 'deficiencies',
		label: labels.DeficienciesLabel,
		prop,
		getSeries: (item) => [
			{
				name: utilLabels.materialWeaknessLabel,
				data: [item.mwCount],
				color: dashboardChartColors.maroon[3]
			},
			{
				name: utilLabels.significantDeficiencyLabel,
				data: [item.sDCount],
				color: dashboardChartColors.maroon[2]
			},
			{
				name: utilLabels.deficiencyLabel,
				data: [item.defCount],
				color: dashboardChartColors.maroon[1]
			}
		]
	});
